import CoverageView from "../components/entityViews/coverage/CoverageView";

export const CoveragePage = () => {
  return (
    <div className="relative flex flex-1 bg-background w-full min-w-0 min-h-0" id="coverage-page">
      <CoverageView />
    </div>
  );
};

export default CoveragePage;
